
/*!
* Copyright (c) Microsoft Corporation.
* All rights reserved. See LICENSE in the project root for license information.
* THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
* TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
*/
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './DataServiceEntities.g';


function getTableQueryResponseQuery(): DataServiceQuery {
  return new DataServiceQuery();
}


export function getTableQueryResponseInput (
  schemaName:
    string,
  tableName:
    string,
  columns:
    string[],
  whereClauses:
    DataServiceEntities.IWhereClause[],
  orderBy:
    string,
  isDescending:
    boolean,
  limit:
    number,
  offset:
    number,
  password:
    string
): IDataServiceRequest {
  const query = getTableQueryResponseQuery();
  return query.createDataServiceRequestForOperation(
    'GetTableQueryResponse',
    true,
    DataServiceEntities.TableQueryResponseEntityExtensionClass
    ,
    'false',
    { bypassCache: 'get', returnEntity: 'DataServiceEntities.ITableQueryResponseEntity' },
    {
      schemaName: schemaName,
      tableName: tableName,
      columns: columns,
      whereClauses: whereClauses,
      orderBy: orderBy,
      isDescending: isDescending,
      limit: limit,
      offset: offset,
      password: password
    }
  );
}

export function getTableQueryResponseAsync (
  context: IContext, schemaName:
    string,
  tableName:
    string,
  columns:
    string[],
  whereClauses:
    DataServiceEntities.IWhereClause[],
  orderBy:
    string,
  isDescending:
    boolean,
  limit:
    number,
  offset:
    number,
  password:
    string
): AsyncResult<DataServiceEntities.ITableQueryResponseEntity> {
  const request = getTableQueryResponseInput(schemaName, tableName, columns, whereClauses, orderBy, isDescending, limit, offset, password);
  return callActionOrExecute<DataServiceEntities.ITableQueryResponseEntity>(request, context.callerContext);
}
